import axios from 'axios';
import { API_URL } from 'src/config';
import { deleteToken } from './token';

const axiosInstance = axios.create({ baseURL: API_URL });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      deleteToken();
    }
    return Promise.reject(error);
  },
);

const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axiosInstance.defaults.headers.common['Area'] = timeZone;

export default axiosInstance;

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];
  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

export const revalidateOnlyStaleOptions = {
  revalidateIfStale: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

export const noRevalidateOnlyStaleOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

export const configMultiPartFormData = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};
